var map = {
	"./img/1959-fiera-campionaria-milano-recto.jpg": 364,
	"./img/1959-fiera-campionaria-milano-spongebob.jpg": 365,
	"./img/1959-fiera-campionaria-milano-verso.jpg": 366,
	"./img/SpongexResize_opt.jpg": 367,
	"./img/animazioni/archivist_frustrazione.gif": 368,
	"./img/animazioni/archivist_fuga.gif": 369,
	"./img/animazioni/archivist_noia.gif": 370,
	"./img/animazioni/archivist_sperperare.gif": 371,
	"./img/animazioni/archivist_stressed.gif": 372,
	"./img/animazioni/archivist_troppo-difficile.gif": 373,
	"./img/animazioni/archivist_viaggio-nel-tempo.gif": 374,
	"./img/animazioni/archivist_wow.gif": 375,
	"./img/badge/archivist_badge_01.jpg": 376,
	"./img/badge/archivist_badge_02.jpg": 377,
	"./img/badge/archivist_badge_03.jpg": 378,
	"./img/badge/archivist_badge_04.jpg": 379,
	"./img/badge/archivist_badge_05.jpg": 380,
	"./img/favicon/favicon.png": 381,
	"./img/gioco2/01-archivio-di-stato-roma.jpg": 382,
	"./img/gioco2/02-magazzino-samuel-zeller-unspalsh.jpg": 383,
	"./img/gioco2/03-ctles-paris.jpg": 384,
	"./img/gioco2/04-scaffalature-componibili.jpg": 385,
	"./img/gioco2/05-frigorifero.jpg": 386,
	"./img/landing_background.png": 387,
	"./img/noSpongexResize_opt.jpg": 388,
	"./img/play_archivist_logo.png": 132,
	"./img/play_archivist_logo_white.png": 133,
	"./img/profili/archivist_columbus.png": 389,
	"./img/profili/archivist_gallilaeus.png": 390,
	"./img/profili/archivist_lamambert.png": 391,
	"./img/sfondi/skin_archivist_logo.png": 360,
	"./img/sfondi/sparkle-1.png": 392,
	"./img/sfondi/sparkle-2.png": 393,
	"./img/sfondi/sparkle-3.png": 394,
	"./img/sfondi/sparkle.png": 395,
	"./img/sfondi/star-1.png": 396,
	"./img/sfondi/star-2.png": 397,
	"./img/sfondi/star-3.png": 398,
	"./img/sfondi/star.png": 399
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/img.*$
// module id = 131
// module chunks = 0